import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import classNames from 'classnames'
import { snakeToPascal } from 'src/util/helpers'

const PrimaryFlavorNotes: React.FC = () => {
    const { primaryFlavorNotes, productData, hintsOfFlavorNotes } = useBrewDetailStore()

    const anyHintsFlavorNotes =
        hintsOfFlavorNotes?.length || productData?.style?.hintsOfFlavorNotes?.length

    const anyPrimaryFlavorNotes = primaryFlavorNotes?.length
        ? primaryFlavorNotes
        : productData?.style?.primaryFlavorNotes?.length
        ? productData?.style?.primaryFlavorNotes
        : null

    const jsxPrimaryFlavorNotes = anyPrimaryFlavorNotes
        ? anyPrimaryFlavorNotes?.map((item) => (
              <UI.Pill
                  key={item}
                  label={snakeToPascal(item.toString())}
                  customClasses='bg-gray-100 text-base py-1 px-3 text-gray-500'
              />
          ))
        : '--'

    const containerClasses = classNames(
        'col-span-2 flex flex-col gap-2 ',
        anyHintsFlavorNotes > 0
            ? 'sm:col-span-1'
            : anyPrimaryFlavorNotes
            ? 'sm:col-span-2'
            : 'sm:col-span-1'
    )

    return (
        jsxPrimaryFlavorNotes && (
            <div className={containerClasses}>
                <span className='text-base font-bold text-gray-300'>Primary Flavor Notes</span>
                <div className='flex flex-wrap gap-1'>{jsxPrimaryFlavorNotes}</div>
            </div>
        )
    )
}

export default PrimaryFlavorNotes
